import { useEntityPageContext } from './EntityContext';

/** The top-posts section, for whichever source's section `as` is. */
const EntityTopPosts = ({ as: Section, ...rest }) => {
    const { entityId, entityType, countryIds, week, year, name } =
        useEntityPageContext();

    return (
        <Section
            week={week}
            year={year}
            {...(entityType === 'brands'
                ? { brands: [entityId] }
                : { categories: [entityId] })}
            countries={countryIds}
            name={name || null}
            {...rest}
        />
    );
};

export default EntityTopPosts;
